import moment from 'moment'
import localforage from 'localforage'

class Security {
    // HASH PASSWORD (SHA-256, stockage offline uniquement)
    static hashPassword(password) {
        if (!crypto || !crypto.subtle) {
            return Promise.resolve(null);
        }
        const msgBuffer = new TextEncoder().encode(password);
        return crypto.subtle.digest('SHA-256', msgBuffer).then(function(hashBuffer) {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        });
    }

    // LOGIN REQUEST
    login(email, password, callback) {
        axios
            .post(
                urlAPI + '/oauth/v2/token',
                {
                    username: email,
                    password: password,
                    grant_type: 'password',
                    client_id: '1_3bcbxd9e24g0gk4swg0kwgcwg4o8k8g4g888kwc44gcc0gwwk4',
                    client_secret: '4ok2x70rlfokc8g0wws8c8kwcokw80k44sg48goc0ok4w0so0k'
                }
            ).then(function (response) {
            if (response.data.access_token && response.data.token_type) {
                localStorage.setItem('email', email);
                callback({'status': true, 'apiKey': response.data.access_token});
                // Stocker le hash du mot de passe en arrière-plan (ne bloque pas le login)
                Security.hashPassword(password).then(function(hash) {
                    if (hash) {
                        localStorage.setItem('pwd', hash);
                    }
                }).catch(function() {});
            }
        })
            .catch(function (error) {
                const desc = error.response ? error.response.data.error_description : null;
                const err = desc
                    ? (desc === 'Invalid username and password combination' ? 'Mauvaise combinaison Login / Mot de passe' : desc)
                    : 'Erreur réseau, vérifiez votre connexion';

                callback({'status': false, 'error': err});
            });
    }

    // Extrait un refus d'acces d'une erreur axios, ou null si ce n'en est pas
    // un (erreur reseau, 403 sans motif connu). Voir MOTIFS_REFUS.
    static refusDepuisErreur(err) {
        if (!err || !err.response || err.response.status !== 403) {
            return null;
        }

        const data = err.response.data;
        const reason = (data && typeof data === 'object') ? data.reason : null;

        if (Security.MOTIFS_REFUS.indexOf(reason) === -1) {
            return null;
        }

        return {reason: reason};
    }

    // Deconnexion consecutive a un refus serveur (MD-565).
    //
    // Purge en plus du logout ordinaire le hash du mot de passe et le profil :
    // sans `pwd`, le chemin hors-ligne de Login.vue ne peut plus revalider le
    // mot de passe en local et reposer lastConnexion, ce qui laissait rentrer
    // un compte dont l'acces vient d'etre revoque.
    //
    // Volontairement separe de logout() : purger `pwd` sur une deconnexion
    // ordinaire casserait la connexion hors-ligne des comptes legitimes.
    //
    // `email` est conserve parce qu'il n'ouvre aucun acces a lui seul : sans
    // `pwd`, le chemin hors-ligne de Login.vue le refuse. Il ne pre-remplit
    // pas le champ pour autant — Login.vue::getEmailIfExist() lit `profil`,
    // qui est purge ici, donc le champ sera vide apres un refus.
    //
    // `offlineActions` est conserve DELIBEREMENT : la file hors-ligne du
    // technicien doit survivre a la deconnexion pour etre poussee une fois le
    // compte reactive. Ne pas "completer" la purge avec.
    //
    // Suppressions individuelles plutot qu'un Promise.all : isLogged() exige
    // lastConnexion ET profil, donc retirer ne serait-ce qu'un des trois suffit
    // a faire retomber la navigation suivante dans le chemin de refus, qui
    // rejouera cette purge. L'operation est auto-reparatrice.
    static logoutRefus(callback) {
        try {
            localStorage.removeItem('pwd');
        } catch (e) { /* localStorage indisponible : rien de plus a faire */ }

        const oublier = function(cle) {
            return localforage.removeItem(cle).catch(function() {});
        };

        Promise.all([
            oublier('api-token'),
            oublier('lastConnexion'),
            oublier('profil')
        ]).then(function() {
            callback();
        });
    }

    // LOGOUT FUNCTION
    logout(callback) {
        localforage
            .removeItem('api-token')
            .then(function () {
                localforage
                    .removeItem('lastConnexion')
                    .then(function () {
                        callback('ok');
                    })
                    .catch(function () {
                        callback('ko');
                    });

            })
            .catch(function () {
                callback('ko');
            });
    }

    // CHECK SESSION
    isLogged(callback) {
        localforage
            .getItem('lastConnexion')
            .then(function (value) {
                if (value == null) {
                    return callback(false);
                }
                var endSession = moment(value).add(12, 'hours');
                if (endSession.isBefore(moment())) {
                    return callback(false);
                }
                localforage.getItem('profil').then(function(profil) {
                    callback(profil !== null);
                }).catch(function() {
                    callback(false);
                });
            })
            .catch(function() {
                callback(false);
            });
    }

    // Motifs de refus connus renvoyes par GET /me (MD-565). Un 403 dont le
    // motif n'est pas dans cette liste n'est PAS traite comme un compte
    // invalide : front et back se deploient separement, et un 403 de
    // proxy/WAF (corps HTML, pas de `reason`) ne doit pas deconnecter.
    static get MOTIFS_REFUS() {
        return ['eval_expired', 'operator_disabled'];
    }

    // Libelle affichable d'un refus renvoye par GET /me (MD-565).
    static libelleRefus(refus) {
        if (refus && refus.reason === 'eval_expired') {
            return "Votre période d'évaluation est terminée. Contactez votre commercial pour activer votre compte.";
        }
        if (refus && refus.reason === 'operator_disabled') {
            return "Votre compte opérateur a été désactivé. Contactez votre administrateur.";
        }
        return "Votre accès à l'application n'est plus valide. Contactez votre administrateur.";
    }

    // callback(recovered, profil, refus)
    //
    // MD-565 : `refus` n'est renseigné que lorsque le serveur refuse
    // explicitement l'accès (403 sur GET /me : évaluation terminée, opérateur
    // désactivé). Une simple erreur réseau laisse `refus` à null et conserve le
    // comportement historique — un technicien hors couverture ne doit jamais
    // être traité comme un compte invalide.
    static tryRefreshProfil(callback) {
        localforage.getItem('api-token').then(function(token) {
            if (!token) return callback(false, null, null);
            axios.get(urlAPI + '/me', {
                headers: { 'Authorization': 'Bearer ' + token }
            }).then(function(result) {
                var profil = result.data;
                localStorage.setItem('canEditDetenteurs', profil.can_edit_detenteurs);
                localStorage.setItem('canEditInstallations', profil.can_edit_installations);
                localStorage.setItem('typeUser', profil.type);
                if (profil.operator) {
                    localStorage.setItem('activateTrackDechets', profil.operator.activate_track_dechets);
                    localStorage.setItem('hasTransporterTd', profil.operator.has_transporter_td);
                    localStorage.setItem('betaTesteur', profil.operator.beta_testeur);
                }
                Promise.all([
                    localforage.setItem('profil', JSON.stringify(profil)),
                    localforage.setItem('lastConnexion', moment().format())
                ]).then(function() {
                    callback(true, profil, null);
                }).catch(function() {
                    callback(false, null, null);
                });
            }).catch(function(err) {
                const refus = Security.refusDepuisErreur(err);
                if (refus) {
                    return callback(false, null, refus);
                }
                callback(false, null, null);
            });
        }).catch(function() {
            callback(false, null, null);
        });
    }

    // TRIGGER WHEN LOGIN FUNCTION IS SUCCESSFUL
    setUserSession(apiKey, callback) {
        let now = moment().format();

        localforage
            .setItem('lastConnexion', now)
            .then(function() {

                localforage
                    .setItem('api-token', apiKey)
                    .then(function() {
                        callback({status: true})
                    })
                    .catch(function (err) {
                        callback({status: false, error: err})
                    });

            })
            .catch(function (err) {
                callback({status: false, error: err})
            });
    }
}

export default Security



// WEBPACK FOOTER //
// ./src/js/core/Security.js